import { useTranslations } from "use-intl";
import { formatCurrency } from "@/app/lib/utils/currency";
import { CollapsibleCard } from "../../CollapsibleCard";

type Props = {
  totalPrice: number;
  totalDiscount: number;
  totalDiscountedPrice: number;
};

export function PriceDetailsCard({
  totalPrice,
  totalDiscount,
  totalDiscountedPrice,
}: Props) {
  const t = useTranslations();

  return (
    <CollapsibleCard title={t("trips.priceDetails.title")} collapsible={false}>
      <dl className="grid grid-cols-2 gap-2 text-sm">
        <dt className="text-text-disabled-primary">{t("trips.basePrice")}</dt>
        <dd className="text-end font-bold">{formatCurrency(totalPrice)}</dd>

        <dt className="text-text-disabled-primary">{t("trips.discount")}</dt>
        <dd className="text-end font-bold">{formatCurrency(totalDiscount)}</dd>

        <dt className="text-text-disabled-primary">{t("paymentMethod")}</dt>
        <dd className="text-end font-bold">{t("qiCard")}</dd>

        <dt className="text-text-disabled-primary">{t("trips.totalPrice")}</dt>
        <dd className="text-end font-bold">
          {formatCurrency(totalDiscountedPrice)}
        </dd>
      </dl>
    </CollapsibleCard>
  );
}
